import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { GetPersonalFavoriteListItemResponse } from "api/generatedApi";

interface Props {
  row: GetPersonalFavoriteListItemResponse;
  onCheck: (id: string | undefined) => void;
  checked: boolean;
}

export const MobileItemRow = (props: Props) => {
  const { row, onCheck, checked } = props;

  return (
    <TableRow data-testid={`account-favorite-row-${row.text}`}>
      <TableCell>
        <Checkbox data-testid="account-favorite-row-checkbox" onChange={() => onCheck(row.id)} onClick={(event) => event.stopPropagation()} checked={checked} />
      </TableCell>
      <TableCell data-testid="account-favorite-row-text" title={row.text ?? ""}>
        <Typography variant="body2">{row.text}</Typography>
        <Typography variant="body2" color={"primary.main"}>
          {row.itemNumber}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
